import { html, css } from 'lit-element';
import { fetchOrders, createIu, concludeUpsell } from '../core/actions';
import { connect } from '../core/connect';
import { auth } from '../core/props';
import { withProduct } from '../core/resolveProperties';
import { TemplateElement } from '../core/base';

export class UpsellButton extends withProduct(TemplateElement) {
  static get styles() {
    return css`
      :host[hidden] {
        display: none;
      }
      :host {
        display: inline-block;
      }
    `;
  }

  static get properties() {
    return {
      ...super.properties,
      upcomingOrderDate: {
        type: String,
        attribute: false
      },
      auth,
      isPreview: { type: Boolean, attribute: false },
      target: { type: String },
      // If set, creates the IU item immediately instead of opening a modal
      skipModal: { type: Boolean, attribute: 'skip-modal' }
    };
  }

  constructor() {
    super();
    this.fetchOrders = () => 0;
    this.createIu = () => 0;
    this.concludeUpsell = () => 0;
    this.addEventListener('click', this.handleClick.bind(this));
  }

  updated(changed) {
    if (changed.has('auth') && this.auth && !this.upcomingOrderDate && !this.isPreview) {
      this.fetchOrders();
    }
  }

  handleClick() {
    let modal;
    if (this.skipModal) {
      this.createIu(this.product, this.nextUpcomingOrder.public_id, 1, false, null);
      this.concludeUpsell(this.product);
    } else if (!this.target && this.offer) {
      // TODO remove offer shadowRoot built in code.
      modal = this.offer.querySelector('og-upsell-modal');
      if (!modal) {
        modal = this.offer.shadowRoot.querySelector('og-upsell-modal');
      }
    } else if (this.target) {
      modal = document.querySelector(this.target);
    } else {
      throw Error('You must specify a target attribute or place this element as child of og-offer');
    }
    if (modal) {
      modal.setAttribute('show', true);
    }
  }

  render() {
    return html`
      <slot>
        <og-next-upcoming-order></og-next-upcoming-order>
      </slot>
    `;
  }
}

export const mapStateToProps = state => ({
  isPreview: state.previewUpsellOffer,
  nextUpcomingOrder: state.previewUpsellOffer ? { public_id: 'preview-order-id' } : state.nextUpcomingOrder
});

export const ConnectedUpsellButton = connect(mapStateToProps, { fetchOrders, createIu, concludeUpsell })(UpsellButton);

export default UpsellButton;
